// React functional component Dialog window to enter the name for a new design

import React, { useState } from "react"
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material"

const ViewSetDialog = ({ open, onClose, viewSet }) => {
  const [values, setValues] = useState({
    name: "",
    description: "",
    purpose: "",
    ...viewSet,
  })

  const [analysis, setAnalysis] = useState()

  const [isAnalysing, setAnalysing] = useState(false)

  const handleSubmit = () => {
    onClose({ action: "update", values: values })
  }

  return (
    <Dialog open={open} onClose={(e) => onClose(undefined)}>
      <DialogTitle>Set Objective</DialogTitle>
      <DialogContent>
        <Stack
          direction="column"
          spacing={3}
          sx={{ marginTop: "15px", marginBottom: "20px" }}
        >
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            value={values.name}
            onChange={(e) =>
              setValues((curr) => ({ ...curr, name: e.target.value }))
            }
            fullWidth
            variant="outlined"
            size="small"
          />
          <TextField
            label="Objective"
            value={values.purpose}
            multiline
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) =>
              setValues((curr) => ({ ...curr, purpose: e.target.value }))
            }
            helperText={
              <Typography variant="caption" component={"span"}>
                What is the end goal you are seeking to achieve? e.g. Create a
                strategic roadmap to improve profitability, Find ways to improve
                the customer experience, minimise CyberRisk, scope a project?
              </Typography>
            }
          />
          <TextField
            label="Description"
            value={values.description}
            multiline
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) =>
              setValues((curr) => ({ ...curr, description: e.target.value }))
            }
          />

          {analysis?.defines_purpose && (
            <Alert severity="success">Objective is clear</Alert>
          )}

          {analysis?.context_purpose_feedback && (
            <Typography
              variant="caption"
              color="text.secondary"
              component={"span"}
              sx={{ marginLeft: "5px" }}
            >
              Alignment of Context and Objective:{" "}
              {analysis?.context_purpose_feedback}
            </Typography>
          )}

          {analysis?.context_matches_purpose && (
            <Alert severity="success">Context and Objective are aligned</Alert>
          )}
        </Stack>
        {isAnalysing && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <CircularProgress size={20} />
            <Typography
              variant="caption"
              component={"span"}
              sx={{ marginLeft: "10px" }}
            >
              Analysing
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => onClose(undefined)}
          sx={{ textTransform: "none" }}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onClose({ action: "delete" })}
          sx={{ textTransform: "none" }}
          variant="outlined"
        >
          Delete
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewSetDialog
